import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { CommonFunction } from '../../../shared/common-function';
declare var $: any;
@Component({
  selector: 'app-our-services',
  templateUrl: './our-services.component.html',
  styleUrls: ['./our-services.component.css']
})
export class OurServicesComponent extends CommonFunction implements OnInit {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    super();
  }

  ngOnInit() {
    if (isPlatformBrowser(this.platformId)) {
      this.createSlick();
    }
  }

  createSlick() {
    $(".our-services").not('.slick-initialized').slick({
      autoplay: false,
      arrows: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      autoplaySpeed: 1500,
      pauseOnHover: false,
      prevArrow: $('.leftRs'),
      nextArrow: $('.rightRs'),
      responsive: [
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
}